<div style="text-align: center">
  <h3>CV Database Report</h3>
  <br />
  <div>
    <div
      class="c-date-picker"
      style="width: 350px; vertical-align: bottom; display: inline-block"
    >
      <div>{{ 'label.Dates' | translate }}:</div>
      <hr-date-range-picker
        class="date-picker"
        [dateFormat]="specialDateFormat"
        [(ngModel)]="filter.dates"
      ></hr-date-range-picker>
    </div>
    <div style="display: inline-block; margin-right: 2em; margin-left: 2em">
      <div>{{ 'label.Website' | translate }}</div>
      <select [(ngModel)]="filter.websiteId">
        <option selected [ngValue]="null"></option>
        <option *ngFor="let item of providerWebsiteList" [ngValue]="item.value">
          {{ item.text }}
        </option>
      </select>
    </div>
    <div style="display: inline-block; margin-right: 2em">
      <p-checkbox
        [(ngModel)]="filter.excludeInternalCustomers"
        binary="true"
        label="w/o HRRA/HH"
      ></p-checkbox>
    </div>
    <p-button
      type="button"
      class="ui-button-secondary top-left"
      (click)="onFilter()"
      label="{{ 'label.Filter' | translate }}"
    ></p-button>
    <p *ngIf="filterErrorMsg" style="color: red; margin-top: 1em">
      {{ filterErrorMsg }}
    </p>
  </div>
  <br />
  <div id="chart">
    <p-chart type="line" [data]="chartData" *ngIf="chartData"></p-chart>
  </div>
  <br />
  <div id="table">
    <p-table [value]="rows" showGridlines [autoLayout]="true" *ngIf="chartData">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 110px" colspan="2"></th>
          <th>{{ 'label.Total' | translate }}</th>
          <th *ngFor="let col of cols">
            {{ col }}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr *ngIf="!row.collapsible || row.collapsed">
          <td colspan="2">
            <i
              *ngIf="row.clickable && row.clicksCollapsed"
              class="fa fa-angle-double-up fa-lg"
              (click)="onHide(row)"
            ></i>
            <i
              *ngIf="row.clickable && !row.clicksCollapsed"
              class="fa fa-angle-double-down fa-lg"
              (click)="onExpand(row)"
            ></i>
            &nbsp;{{ row.header }}
          </td>
          <td>
            <span *ngIf="!row.collapsible"
              ><b>{{ reportData.GetTotal(row.field) }}</b></span
            >
            <span *ngIf="row.collapsible"
              ><b>{{ clicksReport.GetTotal(row.field) }}</b></span
            >
          </td>
          <td *ngFor="let col of cols">
            <span *ngIf="!row.collapsible">{{
              reportData.stats[col][row.field]
            }}</span>
            <span
              *ngIf="
                row.collapsible &&
                clicksReport.clicks[col] &&
                clicksReport.clicks[col][row.field]
              "
              >{{ clicksReport.clicks[col][row.field].count }}</span
            >
            <span
              *ngIf="
                row.collapsible &&
                (!clicksReport.clicks[col] ||
                  !clicksReport.clicks[col][row.field])
              "
              >0</span
            >
          </td>
        </tr>

        <ng-container *ngIf="row.field == 'totalClicks' && row.clicksCollapsed">
          <tr *ngFor="let r of cvDatabaseViewRows">
            <td colspan="2">{{ r?.header }}</td>
            <td>
              <span *ngIf="r?.collapsible"
                ><b>{{ clicksReport?.GetTotal(r.field) }}</b></span
              >
            </td>
            <td *ngFor="let col of cols">
              <span
                *ngIf="
                  r?.collapsible &&
                  clicksReport?.clicks[col] &&
                  clicksReport?.clicks[col][r?.field]
                "
                >{{ clicksReport?.clicks[col][r?.field].count }}</span
              >
              <span
                *ngIf="
                  r?.collapsible &&
                  (!clicksReport?.clicks[col] ||
                    !clicksReport?.clicks[col][r?.field])
                "
                >0</span
              >
            </td>
          </tr>
        </ng-container>

        <ng-container
          *ngIf="row.field == 'cvBoxApplicationViews' && row.clicksCollapsed"
        >
          <tr *ngFor="let r of cvBoxApplicationViewRows">
            <td colspan="2">{{ r?.header }}</td>
            <td>
              <span *ngIf="r?.collapsible"
                ><b>{{ cvBoxClicksReport?.GetTotal(r.field) }}</b></span
              >
            </td>
            <td *ngFor="let col of cols">
              <span
                *ngIf="
                  r?.collapsible &&
                  cvBoxClicksReport?.clicks[col] &&
                  cvBoxClicksReport?.clicks[col][r?.field]
                "
                >{{ cvBoxClicksReport?.clicks[col][r?.field].count }}</span
              >
              <span
                *ngIf="
                  r?.collapsible &&
                  (!cvBoxClicksReport?.clicks[col] ||
                    !cvBoxClicksReport?.clicks[col][r?.field])
                "
                >0</span
              >
            </td>
          </tr>
        </ng-container>

        <ng-container
          *ngIf="row.field == 'annApplicationViews' && row.clicksCollapsed"
        >
          <tr *ngFor="let r of annApplicationViewRows">
            <td colspan="2">{{ r?.header }}</td>
            <td>
              <span *ngIf="r?.collapsible"
                ><b>{{ annClicksReport?.GetTotal(r.field) }}</b></span
              >
            </td>
            <td *ngFor="let col of cols">
              <span
                *ngIf="
                  r?.collapsible &&
                  annClicksReport?.clicks[col] &&
                  annClicksReport?.clicks[col][r?.field]
                "
                >{{ annClicksReport?.clicks[col][r?.field].count }}</span
              >
              <span
                *ngIf="
                  r?.collapsible &&
                  (!annClicksReport?.clicks[col] ||
                    !annClicksReport?.clicks[col][r?.field])
                "
                >0</span
              >
            </td>
          </tr>
        </ng-container>

        <ng-container
          *ngIf="row.field == 'matchingViews' && row.clicksCollapsed"
        >
          <tr *ngFor="let r of matchingViewRows">
            <td colspan="2">{{ r?.header }}</td>
            <td>
              <span *ngIf="r?.collapsible"
                ><b>{{ matchingClicksReport?.GetTotal(r.field) }}</b></span
              >
            </td>
            <td *ngFor="let col of cols">
              <span
                *ngIf="
                  r?.collapsible &&
                  matchingClicksReport?.clicks[col] &&
                  matchingClicksReport?.clicks[col][r?.field]
                "
                >{{ matchingClicksReport?.clicks[col][r?.field].count }}</span
              >
              <span
                *ngIf="
                  r?.collapsible &&
                  (!matchingClicksReport?.clicks[col] ||
                    !matchingClicksReport?.clicks[col][r?.field])
                "
                >0</span
              >
            </td>
          </tr>
        </ng-container>

        <ng-container
          *ngIf="row.field == 'invitesTotal' && row.clicksCollapsed"
        >
          <tr *ngFor="let r of inviteDetailRows" class="invite-detail-row">
            <td
              *ngIf="r.firstOfCustomer"
              [attr.rowspan]="r.rowspan"
              style="text-align: left; vertical-align: middle"
            >
              <b>{{ r.customer }}</b>
            </td>
            <td
              [style.color]="r.color"
              style="text-align: left; white-space: nowrap"
            >
              {{ r.header }}
            </td>
            <td>
              <span [style.color]="r.color">{{
                invitesDetailReport?.GetCustomerStatusTotal(r.customer, r.field)
              }}</span>
            </td>
            <td *ngFor="let col of cols">
              <span
                *ngIf="
                  invitesDetailReport?.details[col] &&
                  invitesDetailReport?.details[col][r.customer]
                "
                [style.color]="r.color"
                >{{ invitesDetailReport.details[col][r.customer][r.field] }}</span
              >
              <span
                *ngIf="
                  !invitesDetailReport?.details[col] ||
                  !invitesDetailReport?.details[col][r.customer]
                "
                [style.color]="r.color"
                >0</span
              >
            </td>
          </tr>
        </ng-container>
      </ng-template>
    </p-table>
  </div>
</div>
